// extracted by mini-css-extract-plugin
module.exports = {"link":"SiteLink_link__1YLTT","arrow":"SiteLink_arrow__h_fXr","siteLink":"SiteLink_siteLink__3ZI6N","linkText":"SiteLink_linkText__3kZuO"};